import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { DatePicker } from "antd";
import CommonSelect from "../../../core/common/commonSelect";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EmpSuccess from "../employees/employeeSuccess";
import {
  createNewCustomer,
  getCustomersById,
  getCustomersLoansById,
  updateCustomersLoansById,
  updatePaymentById,
} from "../../../apis/customers";
import { errorAlert, successAlert } from "../../../style/scss/utils/Alerts";
import { uploadFile } from "../../../apis/auth";
import {
  createNewDisbursement,
  createNewEmi,
  getAllDisbursements,
  getSettlementPreview,
} from "../../../apis/disbursement";
import { createNewLoan } from "../../../apis/loans";
import { getAllProduct, getAllProductByName } from "../../../apis/product";
import Select from "react-select";
import moment from "moment";
import SanctionalLetter from "../../components/customer/sanctional_letter";
import CustomerDetails from "../../components/customer/customer_details";
import DisbursementDetails from "../../components/customer/disbursement";
import CustomerDocument from "../../components/customer/customerDocument";
import GuarantorDetails from "../../components/customer/guarantor_details";
import BankDetails from "../../components/customer/bank_details";
import EMandate from "../../components/customer/e-mandate";
import ENach from "../../components/customer/enach";
import { getAllProductByType } from "../../../apis/productNameList";
type PasswordField = "password" | "confirmPassword";

type OptionType = {
  label: string;
  value: string;
};

const loanInitialData = {
  requestedAmount: "",
  approvalfilecharge: "",
  otherloancharges: "",
  productPrice: "",
  downPayment: "",
  numberOfEmis: "",
};

const paymentValues = {
  paymentAmount: "",
  penaltyAmount: "",
  discount: "",
};

const initialValues = {
  name: "",
  full_name: "",
  user_name: "",
  email: "",
  password: "",
  confirm_password: "",
  phone_number: "",
  company: "",
  about: "",
  adress: "",
  geo_location: "",
};

const disburseValues = {
  DisbursementAmount: "",
  DisbursementDate: "",
  settlementDiscount: "",
  settlementPenalty: "",
  fileCharges: "",
  otherCharges: "",
  start_date: "",
  utrNumber: "",
  utrImageUrl: "",
};

type DisburseResponse = {
  disbursement: string | null;
  emis: string | null;
  status: string;
  id: number | null;
};
type EmiDataResponse = {
  emis: string | null;
  status: string;
  id: number | null;
};

type DisbursementData = {
  key: string;
  srNo: string;
  Status: string;
  id: number | string;
  amount?: string;
  disbursement_date?: string;
  file_charges?: string;
  other_charges?: string;
  start_date?: string;
  type?: string;
  utrImageUrl?: string;
  utrNumber?: string;
  allData: any;
};
type EmiData = {
  key: string;
  srNo: string;
  id: number | string;
  amount?: string;
  due_date?: string;
  status?: string;
};

const CustomerLoanList = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = params.get("id");
  const [loanErrors, setLoanErrors] = useState<any>({});


  const [state, setState] = useState({
    start: moment().subtract(6, "days"),
    end: moment(),
  });
  const { start, end } = state;
  const navigate = useNavigate();

  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [selectedLoanType, setSelectedLoanType] = useState<any>();
  const [selectedLoanCategory, setSelectedLoanCategory] = useState<any>({
    value: "new",
    label: "New Loan",
  });
  const [selectedPayOption, setSelectedPayOption] = useState<any>();
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const [image, setImage] = useState<File | null>(null);
  const [utrImage, setUtrImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [utrImageUrl, setUtrImageUrl] = useState<string>("");
  const [allProducts, setAllProducts] = useState<productData[]>([]);
  const [imeiNumber, setImeiNumber] = useState("");
  const [number1, setNumber1] = useState("");
  const [number2, setNumber2] = useState("");
  const [lockingKitNo, setLockingKitNo] = useState("");
  const [isEdit, setIsEdit] = useState(false)
  const [billImage, setBillImage] = useState("");
  const [billFile, setBillFile] = useState<File | null>(null);
  const [error, setError] = useState<string>("");
  const [products, setProducts] = useState<any>();
  const [customerData, setCustomerData] = useState<any>();
  const [allEmiData, setAllEmiData] = useState<EmiData[]>([]);
  const [amount, setAmount] = useState<number | undefined>();
  const [emi_start_date, setEmiStartDate] = useState<string>();
  const [sanctionalData, setSanctionalData] = useState<any>();
  const [loanFormData, setLoanFormData] = useState(loanInitialData);
  const [paymentFormData, setPaymentFormData] = useState(paymentValues);
  const [disburseFormData, setDisburseFormData] = useState(disburseValues);
  const [settlementPreview, setSettlementPreview] = useState<any>(null);
  const [closePreviousLoan, setClosePreviousLoan] = useState(true);
  const [productName, setProductName] = useState<OptionType[]>([]);
  const [modelNumber, setModelNumber] = useState("");
  const [modelName, setModelName] = useState("");
  const [selectedProductName, setSelectedProductName] =
    useState<OptionType | null>(null);
  const [enachData, setEnachData] = useState();
  const mtIdString = sessionStorage.getItem("info");
  const productData = JSON.parse(mtIdString);
  const {
    full_name,
    user_name,
    email,
    adress,
    geo_location,
    password,
    confirm_password,
    phone_number,
  } = formData;

  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
  };
  const handlePaymentSelect = (option: any | null) => {
    setSelectedPayOption(option || undefined);
  };
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; // Optional chaining to handle undefined cases
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }
      setError("");
      setImage(file);
      setUtrImage(file);
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setImageUrl(response.data.image);
        setUtrImageUrl(response.data.image);
      }
    }
  };

  const handleCancel = () => {
    setImage(null);
    setError("");
  };

  let mtId: {
    permission: string; id: string; type: string
  } | null = null;

  if (mtIdString) {
    try {
      mtId = JSON.parse(mtIdString);
    } catch (error) {
      console.error("Failed to parse sessionStorage info:", error);
    }
  }

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  type EmployeeResponse = {
    type: any;
    loan_type?: "new" | "reloan" | "topup";
    approvalAmount: number;
    requestedAmount: number;
    geo_location: string;
    Image: string;
    products: any;
    CurrentRole: string;
    email: string;
    phoneNumber1: string;
    Designation: string;
    approvalDate: string;
    status: string;
    id: any;
    customer: any;
  };

  type EmployeeData = {
    loan_id: string;
    numberOfEmis: string;
    product_name: any;
    key: any;
    srNo: number;
    EmpId: string;
    approvalAmount: number;
    requestedAmount: number;
    products: any;
    Image: string;
    CurrentRole: string;
    Email: string;
    phoneNumber1: string;
    Designation: string;
    JoiningDate: string;
    Status: string;
    id: any;
    allDetails: any;
    loanAccountNumber: string;
    serialType: string;
    loanCategory?: "new" | "reloan" | "topup";
  };
  const fetchAllEmployees = async () => {
    try {
      const data = {
        start_date: "",
        end_date: "",
      };
      const response = await getCustomersLoansById(id);
      const employeeData = response?.data?.map(
        (item: EmployeeResponse, i: number) => ({
          key: `${item.id}`,
          srNo: `${i + 1}`,
          EmpId: `${i + 1}`,
          approvalAmount: `${item.approvalAmount}`,
          requestedAmount: `${item.requestedAmount}` || "--",
          Image: item.Image ? item.Image : "--",
          CurrentRole: item.CurrentRole || "--",
          product_name: item.products || "--",
          phoneNumber1: item.phoneNumber1 || "--",
          Designation: item.Designation || "--",
          JoiningDate: item.approvalDate || "--",
          Status: item.status || "--",
          id: item.id || "--",
          allDetails: item,
          serialType: item?.type,
          loanCategory: item.loan_type,
          loanAccountNumber: item.customer.loanAccountNumber || "--",
        })
      );
      setEmployeeData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const fetchCustomerById = async () => {
    try {
      const response = await getCustomersById(id);
      if (response.status === true) {
        const data = {
          full_name: response?.data?.full_name,
          phoneNumber1: response.data.phoneNumber1,
          email: response.data.email,
          fatherName: response.data.fatherName,
          gender: response.data.gender,
          dob: response.data.dob,
          PanNumber: response.data.PanNumber,
          aadharNumber: response.data.aadharNumber,
          bankAccountNo: response.data.bankAccountNo,
          bankName: response.data.bankName,
          loanAccountNumber: response.data.loanAccountNumber,
          martialStatus: response.data.martialStatus,
          addressLine1: response.data.current_address?.addressLine1,
          city1: response.data.current_address?.city1,
          state1: response.data.current_address?.state1,
          country1: response.data.current_address?.country1,
          pincode1: response.data.current_address?.pincode1,
          aadharImageUrl: response.data.aadharImageUrl,
          aadharbackimageurl: response.data.aadharbackimageurl,
          bankStatementsImageUrl: response.data.bankStatementsImageUrl,
          panImageUrl: response.data.panImageUrl,
          passportSizePhoto: response.data.passportSizePhoto,
          paySlipImageUrl: response.data.paySlipImageUrl,
          singnatureImageUrl: response.data.singnatureImageUrl,
          allData: response.data,
        };
        setCustomerData(data);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  type productData = {
    [x: string]: any;
    value: any;
    key: number;
    srNo: number;
    label: string;
  };

  type productResponse = {
    [x: string]: any;
    id: any;
    name: string;
  };

  const fetchAllProducts = async () => {
    const data = {
      start_date: "",
      end_date: "",
      product_name: selectedProductName?.value,
    };
    try {
      const response = await getAllProductByName(data);
      const prData = response?.data?.map(
        (item: productResponse, i: number) => ({
          key: `product-${i + 1}`,
          srNo: `${i + 1}`,
          label: `${item.model_no}`,
          model_name: item.name,
          value: item.id || "Not Assigned",
          product_type: item.product_type,
          emi_type: item.emi_type,
        })
      );
      setAllProducts(prData || []);
    } catch (error) { }
  };

  useEffect(() => {
    fetchCustomerById();
    fetchAllEmployees();
    fetchAllDisbursements();
  }, []);

  useEffect(() => {
    productNameListData();
    setProductName([]);
  }, [selectedLoanType]);

  useEffect(() => {
    fetchAllProducts();
  }, [selectedProductName]);

  const handleSanctionLetter = (item: any) => {
    setSanctionalData(item?.data);
  };
  const handleEnachData = (item: any) => {
    setEnachData(item?.data);
  };

  const handleChangeNewStatus = async (data: { data: any }) => {
    const date = new Date();
    const details = data.data.allDetails;
    setProducts(data.data);
    setDisburseFormData({
      ...disburseValues,
      DisbursementAmount: String(data.data.approvalAmount || ""),
    });
    setSettlementPreview(null);
    setClosePreviousLoan(data.data.loanCategory === "reloan");
    if (data.data.Status === "approved") {
      try {
        const preview = await getSettlementPreview(data.data.id);
        setSettlementPreview(preview.data);
      } catch (previewError: any) {
        errorAlert(
          "Unable to calculate settlement",
          previewError?.response?.data?.message ||
            "Please sign in again and retry."
        );
      }
    }

    // Default the approval amount to requested amount minus the loan's file
    // and other charges (both fixed at loan creation time), clamped to 0.
    // Staff can still edit it, but never above the requested amount.
    const requested = Number(data.data.requestedAmount) || 0;
    const fileCharges = Number(details?.approvalfilecharge) || 0;
    const otherCharges = Number(details?.othercharges) || 0;
    setAmount(Math.max(requested - (fileCharges + otherCharges), 0));

    if (details) {
      if (details.type) setImeiNumber(details.type);
      if (details.number1) setNumber1(details.number1);
      if (details.number2) setNumber2(details.number2);
      if (details.locking_kit_no) setLockingKitNo(details.locking_kit_no);
      if (details.bill_image) setBillImage(details.bill_image)
      if (details.type && details.number1 && details.number2 && details.locking_kit_no && details.bill_image) setIsEdit(true)
    }
    if (data.data.product_name?.model_no) {
      setModelNumber(data.data.product_name.model_no);
      setModelName(data.data.product_name.name);
    } else {
      setModelNumber("");
    }
  };
  const department = [
    { value: "Select", label: "Select" },
    { value: "All Branches", label: "All Branches" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
  ];
  const paymentType = [
    { value: "Select", label: "Select" },
    { value: "cash", label: "Cash" },
    { value: "bank", label: "Bank" },
  ];
  const paymentMode = [
    { value: "Select", label: "Select" },
    { value: "UPI", label: "UPI" },
    { value: "CASH", label: "CASH" },
  ];

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const requiredFields = [
      "adress",
      "email",
      "full_name",
      "geo_location",
      "password",
      "phone_number",
      "user_name",
    ];

    const emptyFields = requiredFields.filter(
      (field) => !formData[field as keyof typeof formData]?.trim()
    );

    if (emptyFields.length > 0) {
      console.error(
        `The following fields are empty: ${emptyFields.join(", ")}`
      );
      errorAlert(
        `Please fill out the required fields: ${emptyFields.join(", ")}`
      );
      return;
    }

    const master_Id = mtId?.id || "0";

    const payload = {
      address: formData.adress,
      email: formData.email,
      full_name: formData.full_name,
      password: formData.password,
      phone_number: formData.phone_number,
      user_name: formData.user_name,
      geo_location: formData.geo_location,
      profile_pic: imageUrl,
      retailer_id: master_Id,
      type: "customer",
    };

    const formdata = new FormData();
    formdata.append("address", formData.adress);
    formdata.append("email", formData.email);
    formdata.append("full_name", formData.full_name);
    formdata.append("password", formData.password);
    formdata.append("phone_number", formData.phone_number);
    formdata.append("user_name", formData.user_name);
    formdata.append("geo_location", formData.geo_location);
    formdata.append("profile_pic", image!);
    formdata.append("retailer_id", master_Id);
    formdata.append("type", "customer");

    try {
      const response = await createNewCustomer(payload);
      if (response.status === true) {
        setSuccessCreation(true);
        setImage(null);
        setFormData(initialValues);
        fetchAllEmployees();
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  const handleDisbursementAmount = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setDisburseFormData({ ...disburseFormData, [name]: value });
  };

  const {
    DisbursementAmount,
    DisbursementDate,
    utrNumber,
    settlementDiscount,
    settlementPenalty,
  } = disburseFormData;
  const previousPendingAmount = Number(settlementPreview?.previous_balance || 0);
  const hasPreviousLoan = Boolean(settlementPreview?.previous_loan_id) || allEmployeeData.some(
    (loan) =>
      products?.allDetails?.financer_id != null &&
      String(loan.id) !== String(products?.id) &&
      String(loan.allDetails?.financer_id) === String(products?.allDetails?.financer_id) &&
      ["open", "npa", "disbursed"].includes(loan.Status)
  );
  const shouldSettlePreviousLoan = hasPreviousLoan && closePreviousLoan;
  const settlementDiscountAmount = shouldSettlePreviousLoan ? Number(settlementDiscount || 0) : 0;
  const settlementPenaltyAmount = shouldSettlePreviousLoan ? Number(settlementPenalty || 0) : 0;
  const deductedSettlementAmount = Math.max(
    (shouldSettlePreviousLoan ? previousPendingAmount : 0) -
      settlementDiscountAmount +
      settlementPenaltyAmount,
    0
  );
  const netDisbursementAmount = Math.max(
    Number(DisbursementAmount || 0) - deductedSettlementAmount,
    0
  );

  const handleDisbursement = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    const payload = {
      customer_id: id,
      loan_id: products.id,
      disbursement: {
        other_charges: Number(disburseFormData?.otherCharges),
        amount: Number(disburseFormData?.DisbursementAmount),
        file_charges: Number(disburseFormData?.fileCharges),
        disbursement_date: disburseFormData?.DisbursementDate,
        utrNumber: disburseFormData?.utrNumber,
        utrImageUrl: utrImageUrl,
        type: selectedPayOption?.value,
        start_date: disburseFormData?.start_date,
        settlement_discount: shouldSettlePreviousLoan ? Number(disburseFormData?.settlementDiscount || 0) : 0,
        settlement_penalty: shouldSettlePreviousLoan ? Number(disburseFormData?.settlementPenalty || 0) : 0,
        close_previous_loan: shouldSettlePreviousLoan,
      },
    };
    try {
      const response = await createNewDisbursement(payload);
      if (response.status === true) {
        const settlement = Number(response.data?.settlement_amount || 0);
        const netAmount = Number(response.data?.net_disbursement_amount || 0);
        await successAlert(
          "Loan disbursed",
          settlement > 0
            ? `Previous loan settled: ₹${settlement.toLocaleString("en-IN")}. Net disbursement: ₹${netAmount.toLocaleString("en-IN")}.`
            : `Net disbursement: ₹${netAmount.toLocaleString("en-IN")}.`
        );
        fetchAllEmployees();
        setDisburseFormData(disburseValues);
        setClosePreviousLoan(false);
        setUtrImage(null);
        setSelectedOption(null);
        setSelectedPayOption(null);
      }
    } catch (error: any) {
      errorAlert(
        "Disbursement failed",
        error?.response?.data?.message || "Unable to disburse this loan"
      );
    }
  };

  const {
    requestedAmount,
    approvalfilecharge,
    otherloancharges,
    productPrice,
    downPayment,
    numberOfEmis,
  } = loanFormData;
  const handleLoanOnChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setLoanFormData({ ...loanFormData, [name]: value });
  };
  const addLoan = async (event: any) => {
    const user = JSON.parse(sessionStorage.getItem("info"));

    let errors: any = {};

    if (!selectedLoanType) errors.selectedLoanType = "Loan type is required.";
    if (!selectedLoanCategory)
      errors.selectedLoanCategory = "Loan category is required.";
    if (!selectedProductName)
      errors.selectedProductName = "Product name is required.";
    if (!selectedOption) errors.selectedOption = "Model number is required.";
    if (!requestedAmount)
      errors.requestedAmount = "Requested amount is required.";
    if (!approvalfilecharge)
      errors.approvalfilecharge = "Approval file charge is required.";
    if (!otherloancharges)
      errors.otherloancharges = "Other charges are required.";
    if (!productPrice)
      errors.productPrice = "Product price are required.";
    if (!downPayment)
      errors.downPayment = "Down Payment are required.";
    if (!numberOfEmis) errors.numberOfEmis = "Number of EMIs is required.";

    setLoanErrors(errors);

    // if (Object.keys(errors).length > 0) {
    //   return; // Stop if there are any errors
    // }
    event.preventDefault();

    const payload = {
      customer_id: id,
      interest_id: selectedOption?.value,
      requestedAmount: requestedAmount,
      approvalDate: new Date(),
      status: "pending",
      approvalfilecharge: approvalfilecharge,
      othercharges: otherloancharges,
      product_prices: productPrice,
      down_payment: downPayment,
      numberOfEmis: numberOfEmis,
      loan_type: selectedLoanCategory?.value || "new",
      userId: user.id,
      usertype: user.type,
    };
    const response = await createNewLoan(payload);
    if (response.status === true) {
      setSelectedOption(undefined);
      setSelectedLoanCategory({ value: "new", label: "New Loan" });
      setLoanFormData(loanInitialData);
      fetchAllEmployees();
    }
  };
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const handleSubmitStatus = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    const newErrors: { [key: string]: string } = {};

    if (!amount && amount !== 0) {
      newErrors.amount = "Approval amount is required";
    } else if (amount > (Number(products?.requestedAmount) || 0)) {
      newErrors.amount = "Approval amount cannot exceed the requested amount";
    }

    if (!emi_start_date) {
      newErrors.emi_start_date = "Start EMI Date is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return; // Don't submit
    }

    setErrors({});
    const date = new Date();
    const formattedDate = date.toISOString().split("T")[0];
    try {
      const payload = {
        customer_id: id,
        approvalDate: formattedDate,
        approvalAmount: amount,
        status: "approved",
      };

      const response = await updateCustomersLoansById(products?.id, payload);
      if (response.status === true) {
        fetchAllEmployees();
        setAmount(0);

        const EmiPayload = await {
          customer_id: id,
          loan_id: products.allDetails.id,
          emiCalculation: {
            amount: Number(amount),
            file_charges: Number(products?.allDetails?.approvalfilecharge),
            other_charges: Number(products?.allDetails?.othercharges),
            start_date: emi_start_date,
          },
        };

        const responseDis = await createNewEmi(EmiPayload);
        if (responseDis.status === true) {
          fetchAllEmployees();
        }
      }
    } catch (error) {
      console.error(error, "error");
    }
  };

  const handleReject = async () => {
    try {
      const date = new Date();
      const formattedDate = date.toISOString().split("T")[0];
      const payload = {
        customer_id: id,
        approvalDate: formattedDate,
        approvalAmount: amount || 0,
        status: "reject",
      };

      const response = await updateCustomersLoansById(products?.id, payload);
      if (response.status === true) {
        fetchAllEmployees();
        setAmount(0);
      }
    } catch (error) {
      console.error("Error rejecting loan:", error);
    }
  };

  const handleModalSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const date = new Date();

    const formData = new FormData();
    formData.append("image", billFile);

    const response = await uploadFile(formData);
    const fileUrl = response.data.image;

    try {
      const payload = {
        model: "test",
        number1: number1,
        number2: number2,
        locking_kit_no: lockingKitNo,
        bill_image: fileUrl,
        type: imeiNumber,
      };
      const response = await updateCustomersLoansById(products?.id, payload);
      if (response.status === true) {
        fetchAllEmployees();
        setAmount(0);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };



  const [allDisbursementData, setDisbursementData] = useState<
    DisbursementData[]
  >([]);

  const fetchAllDisbursements = async () => {
    try {
      const response = await getAllDisbursements(id);
      fetchAllEmis(response?.data);
      const disburseData = response?.data?.map(
        (item: DisburseResponse, i: number) => {
          const parsedDisbursement = item?.disbursement
            ? item?.disbursement
            : {};
          return {
            key: `dis-${item.id}`,
            srNo: `${i + 1}`,
            ...parsedDisbursement,
            Status: item.status || "Not Assigned",
            id: item.id || "Not Assigned",
            allData: item,
          };
        }
      );

      setDisbursementData(disburseData || []);
    } catch (error) {
      console.error("Error fetching disbursements:", error);
    }
  };

  const fetchAllEmis = async (data: any[]) => {
    try {
      const emisData = data?.flatMap((item: EmiDataResponse, i: number) => {
        const parsedEmis = Array.isArray(item.emis) ? item.emis : [];
        return parsedEmis?.map((emi: any, index: number) => ({
          key: `emi-${i}-${index}`,
          srNo: `${index + 1}`,
          ...emi,
          Status: item.status || "Not Assigned",
          id: item.id || "Not Assigned",
        }));
      });
      setAllEmiData(emisData || []);
    } catch (error) {
      console.error("Error processing EMIs:", error);
    }
  };

  const handleOnChangePayment = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setPaymentFormData({ ...paymentFormData, [name]: value });
  };

  const { paymentAmount, penaltyAmount, discount } = paymentFormData;
  const handlePayment = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const date = new Date();
    const formattedDate = date.toISOString().split("T")[0];
    const payload = {
      paymentMode: selectedOption?.value,
      paymentAmount: paymentAmount,
      paymentDate: formattedDate,
      customerId: id,
      loanId: 1005,
      emiId: products?.emi_no,
      status: "Completed",
      penaltyAmount: penaltyAmount,
      discount: discount,
    };
    try {
      const response = await updatePaymentById(id, payload);
    } catch (error) {
      console.error(error, "error");
    }
  };

  const columns = [
    {
      title: "Sr No",
      dataIndex: "srNo",
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: "Customer Account Number",
      dataIndex: "loanAccountNumber",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.loanAccountNumber.localeCompare(b.loanAccountNumber),
      render: (_: any, record: EmployeeData) => (
        <>
          <div>{record?.allDetails?.loan_id || "-"}</div>
        </>
      ),
    },
    {
      title: "Requested Amount",
      dataIndex: "requestedAmount",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="avatar avatar-md"></div>
          <div className="ms-2">
            <p className="text-dark mb-0">{record.requestedAmount}</p>
          </div>
        </div>
      ),
    },
    {
      title: "Loan File Charges",
      dataIndex: "filecharges",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="avatar avatar-md"></div>
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record.allDetails.approvalfilecharge}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Loan Other Charges",
      dataIndex: "othercharges",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="avatar avatar-md"></div>
          <div className="ms-2">
            <p className="text-dark mb-0">{record.allDetails.othercharges}</p>
          </div>
        </div>
      ),
    },
    {
      title: "Approval Date",
      dataIndex: "JoiningDate",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        new Date(a.JoiningDate).getTime() - new Date(b.JoiningDate).getTime(),
    },
    {
      title: "Approval Amount",
      dataIndex: "approvalAmount",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="avatar avatar-md"></div>
          <div className="ms-2">
            <p className="text-dark mb-0">{record.approvalAmount}</p>
          </div>
        </div>
      ),
    },

    {
      title: "Product Name",
      dataIndex: "requestedAmount",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.product_name.name}</p>
          </div>
        </div>
      ),
    },
    {
      title: "ROI",
      dataIndex: "requestedAmount",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.product_name.rate}</p>
          </div>
        </div>
      ),
    },
    {
      title: "Product Type",
      dataIndex: "product_type",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.product_name.product_type}</p>
          </div>
        </div>
      ),
    },
    {
      title: "Loan Category",
      dataIndex: "loan_type",
      render: (_: any, record: EmployeeData) => {
        const labels = {
          new: "New Loan",
          reloan: "Reloan",
          topup: "Top-up",
        };
        return record.loanCategory ? labels[record.loanCategory] : "--";
      },
    },
    {
      title: "Model Name",
      dataIndex: "emi_type",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record.product_name.model_no || "--"}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "EMIS",
      dataIndex: "emi_type",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record.allDetails.numberOfEmis || "--"}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Product Price",
      dataIndex: "emi_type",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record.allDetails.product_prices || "--"}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Down Payment",
      dataIndex: "emi_type",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record.allDetails.down_payment || "--"}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: EmployeeData) => {
        const isClosed = text === "close" || text === "closed";
        return (
          <span className="dropdown">
            <div
              className={`badge btn btn-white ${
                text === "approved" || isClosed ? "badge-success" : "badge-danger"
              } d-inline-flex align-items-center badge-xs`}
            >
              <i className="ti ti-point-filled me-1" />
              {isClosed ? "Loan Closed" : text}
            </div>
          </span>
        );
      },
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Status.localeCompare(b.Status),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: EmployeeData) => (
        <div className="d-inline-flex">
          {(mtId?.type === "financer" || mtId?.permission === "Approved") && (
            <div
              className="btn btn-primary d-flex align-items-center"
              style={{ marginRight: 7 }}
            >
              {record?.Status === "close" || record?.Status === "closed" ? (
                <div>{"Loan Closed"}</div>
              ) : record?.Status !== "disbursed" ? (
                record?.Status === "approved" ? (
                  <div
                    data-bs-toggle="modal"
                    onClick={() => handleChangeNewStatus({ data: record })}
                    data-bs-target="#disburse_modal"
                  >
                    {"Disbursement"}
                  </div>
                ) : record?.Status === "reject" ? (
                  <div className="text-white">{"Rejected"}</div>
                ) : (
                  <div
                    data-bs-toggle="modal"
                    onClick={() => handleChangeNewStatus({ data: record })}
                    data-bs-target="#approve_modal"
                  >
                    {"Approve"}
                  </div>
                )
              ) : (
                <div>{"Disbursed"}</div>
              )}
            </div>
          )}
        </div>
      ),
    },
    // {
    //   title: "E-NACH Mandate",
    //   dataIndex: "actions",
    //   render: (text: string, record: EmployeeData) => (
    //     <div className="d-inline-flex">
    //       {(record?.Status === "approved" ||
    //         record?.Status === "disbursed") && (
    //         <div className="btn btn-primary d-flex align-items-center">
    //           <div
    //             data-bs-toggle="modal"
    //             onClick={() => handleEnachData({ data: record?.allDetails })}
    //             data-bs-target="#enach"
    //           >
    //             {"E-Nach"}
    //           </div>
    //         </div>
    //       )}
    //     </div>
    //   ),
    // },
    // <div className="mb-2">
    //               <Link
    //                 to="#"
    //                 data-bs-toggle="modal"
    //                 data-inert={true}
    //                 data-bs-target="#nach"
    //                 className="btn btn-primary d-flex align-items-center"
    //               >
    //                 E-Nach
    //               </Link>
    //             </div>
    {
      title: "Sanction Letter",
      dataIndex: "actions",
      render: (text: string, record: EmployeeData) => (
        <div className="d-inline-flex">
          {(record?.Status === "approved" ||
            record?.Status === "disbursed") && (
              <div className="btn btn-primary d-flex align-items-center">
                <div
                  data-bs-toggle="modal"
                  onClick={() =>
                    handleSanctionLetter({ data: record.allDetails })
                  }
                  data-bs-target="#sanction_details"
                >
                  {"Sanction Letter"}
                </div>
              </div>
            )}
        </div>
      ),
    },
  ];

  const imeiOptions = [
    { value: "IMEI No", label: "IMEI No" },
    { value: "Serial No", label: "Serial No" },
  ];
  const productNameListData = async () => {
    const data = {
      user_type: productData.type,
      user_id: productData.id,
      product_type: selectedLoanType?.value,
    };
    const response = await getAllProductByType(data);

    const formatted: OptionType[] = response?.data?.map((item: any) => ({
      label: item.product_name,
      value: item.product_name,
    }));

    setProductName(formatted);
  };

  return (
    <>
      <div className="page-wrapper customer-loan-mobile-page">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <div className="mb-2">
                <button
                  className="btn btn-primary d-flex align-items-center"
                  onClick={() => navigate(-1)} // Go back to the previous page
                >
                  Back
                </button>
              </div>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {(JSON.parse(mtIdString)?.type !== "financer" && JSON.parse(mtIdString)?.type !== "customer") && (
                <div className="mb-2">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#add_loan"
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add New Loan
                  </Link>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header customer-detail-nav-header">
              <div className="customer-detail-nav" role="navigation" aria-label="Customer details sections">
                <div className="customer-detail-nav__item">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#show_bank"
                    className="btn btn-primary customer-detail-nav__button"
                  >
                    <i className="ti ti-building-bank" />
                    Bank Details
                  </Link>
                </div>{" "}
                <div className="customer-detail-nav__item">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#show_guarantor"
                    className="btn btn-primary customer-detail-nav__button"
                  >
                    <i className="ti ti-users-group" />
                    Guarantor Details
                  </Link>
                </div>{" "}
                {/* <div className="mb-2">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#e-mandate"
                    className="btn btn-primary d-flex align-items-center"
                  >
                    E-Mandate
                  </Link>
                </div>{" "} */}
                {/* <div className="mb-2">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#nach"
                    className="btn btn-primary d-flex align-items-center"
                  >
                    E-Nach
                  </Link>
                </div>{" "} */}
                <div className="customer-detail-nav__item">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#show_details"
                    className="btn btn-primary customer-detail-nav__button"
                  >
                    <i className="ti ti-user-circle" />
                    Customer Details
                  </Link>
                </div>{" "}
                <div className="customer-detail-nav__item">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#documents_details"
                    className="btn btn-primary customer-detail-nav__button"
                  >
                    <i className="ti ti-files" />
                    Documents
                  </Link>
                </div>
                <div className="customer-detail-nav__item">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#disburse_details"
                    className="btn btn-primary customer-detail-nav__button"
                  >
                    <i className="ti ti-cash-banknote" />
                    Disbursement
                  </Link>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {allEmployeeData && allEmployeeData.length > 0 && (
                <Table
                  dataSource={allEmployeeData}
                  columns={columns}
                  Selection={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Customers</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="address-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#address"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Permissions
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                            <i className="ti ti-photo text-gray-2 fs-16" />
                          </div>

                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Upload Profile Image</h6>
                              <p className="fs-12">
                                Image should be below 4 MB
                              </p>
                              {error && <p className="text-danger">{error}</p>}
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                Upload
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                />
                              </div>
                              <Link
                                to="#"
                                className="btn btn-light btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </Link>
                            </div>
                            {image && (
                              <div className="mt-3">
                                <p>Preview:</p>
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt="Profile Preview"
                                  className="img-thumbnail"
                                  style={{
                                    maxWidth: "150px",
                                    maxHeight: "150px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Full Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="full_name"
                            value={full_name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            user_name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="user_name"
                            value={user_name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="phone_number"
                            value={phone_number}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            name="email"
                            value={email}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 ">
                          <label className="form-label">
                            Password <span className="text-danger"> *</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.password
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                              name="password"
                              value={password}
                              onChange={handleChange}
                            />
                            <span
                              className={`ti toggle-passwords ${passwordVisibility.password
                                ? "ti-eye"
                                : "ti-eye-off"
                                }`}
                              onClick={() =>
                                togglePasswordVisibility("password")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 ">
                          <label className="form-label">
                            Confirm Password{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.confirmPassword
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                              name="confirm_password"
                              value={confirm_password}
                              onChange={handleChange}
                            />
                            <span
                              className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                ? "ti-eye"
                                : "ti-eye-off"
                                }`}
                              onClick={() =>
                                togglePasswordVisibility("confirmPassword")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Address <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="adress"
                            value={adress}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Geo Location <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="geo_location"
                            value={geo_location}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="edit_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Edit Customers</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form action={all_routes.employeeList}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab2"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info2"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="address-tab2"
                      data-bs-toggle="tab"
                      data-bs-target="#address2"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Address
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="bank-tab3"
                      data-bs-toggle="tab"
                      data-bs-target="#bank3"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Bank-Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="verification-tab4"
                      data-bs-toggle="tab"
                      data-bs-target="#verification4"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Verification Images
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="basic-info2"
                  role="tabpanel"
                  aria-labelledby="info-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                            <ImageWithBasePath
                              src="assets/img/users/user-13.jpg"
                              alt="img"
                              className="rounded-circle"
                            />
                          </div>
                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Upload Profile Image</h6>
                              <p className="fs-12">
                                Image should be below 4 mb
                              </p>
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                Upload
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  multiple
                                />
                              </div>
                              <Link to="#" className="btn btn-light btn-sm">
                                Cancel
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            First Name <span className="text-danger"> *</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Last Name</label>
                          <input type="email" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Employee ID <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="Emp-001"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Joining Date <span className="text-danger"> *</span>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format={{
                                format: "DD-MM-YYYY",
                                type: "mask",
                              }}
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            user_name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="Anthony"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            defaultValue="anthony@example.com	"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 ">
                          <label className="form-label">
                            Password <span className="text-danger"> *</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.password
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                            />
                            <span
                              className={`ti toggle-passwords ${passwordVisibility.password
                                ? "ti-eye"
                                : "ti-eye-off"
                                }`}
                              onClick={() =>
                                togglePasswordVisibility("password")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 ">
                          <label className="form-label">
                            Confirm Password{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.confirmPassword
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                            />
                            <span
                              className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                ? "ti-eye"
                                : "ti-eye-off"
                                }`}
                              onClick={() =>
                                togglePasswordVisibility("confirmPassword")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="(123) 4567 890"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Super-Customers</label>
                          <CommonSelect
                            className="select"
                            options={department}
                            defaultValue={department[1]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="address2"
                  role="tabpanel"
                  aria-labelledby="address-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body">
                    <div className="card bg-light-500 shadow-none">
                      <div className="card-body d-flex align-items-center justify-content-between flex-wrap row-gap-3"></div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-inert={true}
                      data-bs-target="#success_modal"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="bank3"
                  role="tabpanel"
                  aria-labelledby="basic-info2"
                  tabIndex={0}
                >
                  <div className="modal-body">
                    <div className="card bg-light-500 shadow-none">
                      <div className="card-body d-flex align-items-center justify-content-between flex-wrap row-gap-3"></div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-inert={true}
                      data-bs-target="#success_modal"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="verification4"
                  role="tabpanel"
                  aria-labelledby="verification-tab4"
                  tabIndex={0}
                >
                  <div className="modal-body">
                    <div className="card bg-light-500 shadow-none">
                      <div className="card-body d-flex align-items-center justify-content-between flex-wrap row-gap-3"></div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-inert={true}
                      data-bs-target="#success_modal"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="disburse_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center"></div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleDisbursement}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab3"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info2"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Disbursement Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="basic-info2"
                  role="tabpanel"
                  aria-labelledby="info-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Gross Disbursement Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="DisbursementAmount"
                            value={DisbursementAmount}
                            onChange={handleDisbursementAmount}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Previous Pending Balance</label>
                          <input
                            type="text"
                            value={`₹${previousPendingAmount.toLocaleString("en-IN")}`}
                            className="form-control"
                            readOnly
                          />
                        </div>
                      </div>
                      {hasPreviousLoan && (
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="close-previous-loan">
                              Close Previous Loan?
                            </label>
                            <select
                              id="close-previous-loan"
                              className="form-select"
                              value={closePreviousLoan ? "yes" : "no"}
                              onChange={(event) => setClosePreviousLoan(event.target.value === "yes")}
                            >
                              <option value="yes">Yes, settle and close previous loan</option>
                              <option value="no">No, continue previous loan</option>
                            </select>
                          </div>
                        </div>
                      )}
                      {shouldSettlePreviousLoan && (
                        <>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Settlement Discount</label>
                              <input
                                type="number"
                                min="0"
                                max={previousPendingAmount}
                                step="0.01"
                                name="settlementDiscount"
                                value={settlementDiscount}
                                onChange={handleDisbursementAmount}
                                className="form-control"
                                placeholder="0"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Settlement Penalty</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                name="settlementPenalty"
                                value={settlementPenalty}
                                onChange={handleDisbursementAmount}
                                className="form-control"
                                placeholder="0"
                              />
                            </div>
                          </div>
                        </>
                      )}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Settlement Deduction</label>
                          <input
                            type="text"
                            value={`₹${deductedSettlementAmount.toLocaleString("en-IN")}`}
                            className="form-control"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Net Amount to Disburse</label>
                          <input
                            type="text"
                            value={`₹${netDisbursementAmount.toLocaleString("en-IN")}`}
                            className="form-control fw-bold"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            UTR Number
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="utrNumber"
                            value={utrNumber}
                            onChange={handleDisbursementAmount}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="profile-upload">
                        <div className="mb-2">
                          <h6 className="mb-1">Upload Utr Image</h6>
                          <p className="fs-12">Image should be below 4 MB</p>
                          {error && <p className="text-danger">{error}</p>}
                        </div>
                        <div className="profile-uploader d-flex align-items-center">
                          <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                            {utrImage ? "Replace" : "Upload"}
                            <input
                              type="file"
                              className="form-control image-sign"
                              accept="image/*"
                              onChange={handleFileChange}
                            />
                          </div>
                          <Link
                            to="#"
                            className="btn btn-light btn-sm"
                            onClick={handleCancel}
                          >
                            Cancel
                          </Link>
                        </div>
                        {utrImage && (
                          <div className="mt-3">
                            <p>Preview:</p>
                            <img
                              src={URL.createObjectURL(utrImage)}
                              alt="Profile Preview"
                              className="img-thumbnail"
                              style={{
                                maxWidth: "150px",
                                maxHeight: "150px",
                              }}
                            />
                          </div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Disbursement Date{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="date"
                            name="DisbursementDate"
                            value={DisbursementDate}
                            onChange={handleDisbursementAmount}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Select Payment Type
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={paymentType}
                            value={selectedOption}
                            onChange={handlePaymentSelect}
                            placeholder="Select Payment Type"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="payment_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center"></div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handlePayment}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab4"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info2"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Payment Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="basic-info2"
                  role="tabpanel"
                  aria-labelledby="info-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Emi Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="DisbursementAmount"
                            value={products?.amount || 0}
                            className="form-control"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Payment Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="paymentAmount"
                            value={paymentAmount}
                            onChange={handleOnChangePayment}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Due Date
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="utrNumber"
                            value={products?.due_date}
                            className="form-control"
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Penalty Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="penaltyAmount"
                            value={penaltyAmount}
                            onChange={handleOnChangePayment}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Discount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="discount"
                            value={discount}
                            onChange={handleOnChangePayment}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Select Payment Mode
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={paymentMode}
                            value={selectedOption}
                            onChange={handleSelect}
                            placeholder="Payment Mode"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_loan">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">Add New Loan</div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="basic-info2"
                  role="tabpanel"
                  aria-labelledby="info-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Product Type</label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={[
                              { value: "Device Loan", label: "Device Loan" },
                              { value: "Others Loan", label: "Others Loan " },
                            ]}
                            value={selectedLoanType}
                            // onChange={(option) => setSelectedLoanType(option)}
                            onChange={(option) => {
                              setSelectedLoanType(option);
                              setLoanErrors((prevErrors) => ({
                                ...prevErrors,
                                selectedLoanType: "",
                              }));
                            }}
                            placeholder="Select Products"
                          />
                          {loanErrors.selectedLoanType && (
                            <small className="text-danger">
                              {loanErrors.selectedLoanType}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Loan Category <span className="text-danger">*</span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={[
                              { value: "new", label: "New Loan" },
                              { value: "reloan", label: "Reloan" },
                              { value: "topup", label: "Top-up" },
                            ]}
                            value={selectedLoanCategory}
                            onChange={(option) => {
                              setSelectedLoanCategory(option);
                              setLoanErrors((previous) => ({
                                ...previous,
                                selectedLoanCategory: "",
                              }));
                            }}
                            placeholder="Select loan category"
                          />
                          {loanErrors.selectedLoanCategory && (
                            <small className="text-danger">
                              {loanErrors.selectedLoanCategory}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Product Name <span className="text-danger"> *</span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            maxMenuHeight={420}
                            options={productName}
                            value={selectedProductName}
                            onChange={(option) => {
                              setSelectedProductName(option);
                              setFormData({
                                ...formData,
                                name: option?.value || "",
                              });
                              setLoanErrors((prevErrors) => ({
                                ...prevErrors,
                                selectedProductName: "",
                              }));
                            }}
                            placeholder="--Select Product Name--"
                          />
                          {loanErrors.selectedProductName && (
                            <small className="text-danger">
                              {loanErrors.selectedProductName}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Model Number</label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            maxMenuHeight={420}
                            options={allProducts
                              .filter(
                                (item) =>
                                  selectedLoanType?.value === item?.product_type
                              )
                              ?.map((item) => ({
                                label: `${item.label} (${item.emi_type})`,
                                value: item.value,
                                fullItem: item,
                              }))}
                            value={selectedOption}
                            onChange={(option) => {
                              handleSelect(option);
                              setLoanErrors((prevErrors) => ({
                                ...prevErrors,
                                selectedOption: "",
                              }));
                            }}
                            placeholder="Select Products"
                          />
                          {loanErrors.selectedOption && (
                            <small className="text-danger">
                              {loanErrors.selectedOption}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Requested Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            required
                            type="number"
                            name="requestedAmount"
                            value={requestedAmount}
                            // onChange={handleLoanOnChange}
                            onChange={(e) => {
                              handleLoanOnChange(e);
                              setLoanErrors((prevErrors) => ({
                                ...prevErrors,
                                requestedAmount: "",
                              }));
                            }}
                            className="form-control"
                          />
                          {loanErrors.requestedAmount && (
                            <small className="text-danger">
                              {loanErrors.requestedAmount}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Approval File charge{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            required
                            name="approvalfilecharge"
                            value={approvalfilecharge}
                            onChange={(e) => {
                              handleLoanOnChange(e);
                              setLoanErrors((prevErrors) => ({
                                ...prevErrors,
                                approvalfilecharge: "",
                              }));
                            }}
                            className="form-control"
                          />
                          {loanErrors.approvalfilecharge && (
                            <small className="text-danger">
                              {loanErrors.approvalfilecharge}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Other charges{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            required
                            type="number"
                            name="otherloancharges"
                            value={otherloancharges}
                            onChange={(e) => {
                              handleLoanOnChange(e);
                              setLoanErrors((prevErrors) => ({
                                ...prevErrors,
                                otherloancharges: "",
                              }));
                            }}
                            className="form-control"
                          />
                          {loanErrors.otherloancharges && (
                            <small className="text-danger">
                              {loanErrors.otherloancharges}
                            </small>
                          )}
                        </div>
                      </div>

                      {selectedLoanType?.value === "Device Loan" &&
                        (<>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Product Price{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                required
                                type="number"
                                name="productPrice"
                                value={productPrice}
                                onChange={(e) => {
                                  handleLoanOnChange(e);
                                  setLoanErrors((prevErrors) => ({
                                    ...prevErrors,
                                    product_price: "",
                                  }));
                                }}
                                className="form-control"
                              />
                              {loanErrors.productPrice && (
                                <small className="text-danger">
                                  {loanErrors.productPrice}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Down Payment{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                required
                                type="number"
                                name="downPayment"
                                value={downPayment}
                                onChange={(e) => {
                                  handleLoanOnChange(e);
                                  setLoanErrors((prevErrors) => ({
                                    ...prevErrors,
                                    downPayment: "",
                                  }));
                                }}
                                className="form-control"
                              />
                              {loanErrors.downPayment && (
                                <small className="text-danger">
                                  {loanErrors.downPayment}
                                </small>
                              )}
                            </div>
                          </div>
                        </>
                        )}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Number Of Emis{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            required
                            type="number"
                            name="numberOfEmis"
                            value={numberOfEmis}
                            onChange={(e) => {
                              handleLoanOnChange(e);
                              setLoanErrors((prevErrors) => ({
                                ...prevErrors,
                                numberOfEmis: "",
                              }));
                            }}
                            className="form-control"
                          />
                          {loanErrors.numberOfEmis && (
                            <small className="text-danger">
                              {loanErrors.numberOfEmis}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={addLoan}
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="approve_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center"></div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitStatus}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab6"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info2"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Loan Approval Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="basic-info2"
                  role="tabpanel"
                  aria-labelledby="info-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Customer Requested Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            required
                            type="number"
                            value={products?.requestedAmount}
                            disabled
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Approval Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            required
                            type="number"
                            max={Number(products?.requestedAmount) || undefined}
                            value={amount ?? 0}
                            onChange={(e) => {
                              const requested = Number(products?.requestedAmount) || 0;
                              const entered = Number(e.target.value) || 0;

                              if (entered > requested) {
                                setAmount(requested);
                                setErrors((prev) => ({
                                  ...prev,
                                  amount: "Approval amount cannot exceed the requested amount",
                                }));
                              } else {
                                setAmount(entered);
                                setErrors((prev) => ({ ...prev, amount: "" }));
                              }
                            }}
                            className="form-control"
                          />
                          {errors.amount && (
                            <small className="text-danger">
                              {errors.amount}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Start Emi Date
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            required
                            type="date"
                            name="start_date"
                            value={emi_start_date}
                            // onChange={(e) => setEmiStartDate(e.target.value)}
                            onChange={(e) => {
                              setEmiStartDate(e.target.value);
                              setErrors((prev) => ({
                                ...prev,
                                emi_start_date: "",
                              }));
                            }}
                            className="form-control"
                          />
                          {errors.emi_start_date && (
                            <small className="text-danger">
                              {errors.emi_start_date}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger me-2"
                      onClick={handleReject}
                      data-bs-dismiss="modal"
                    >
                      Reject
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Approve
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade " id="device_details">
        <div className="modal-dialog modal-dialog-centered modal-lg ">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                {" "}
                <button
                  className="nav-link"
                  id="info-tab7"
                  data-bs-toggle="tab"
                  data-bs-target="#basic-info2"
                  type="button"
                  role="tab"
                  aria-selected="true"
                >
                  Device Details
                </button>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setImeiNumber("");
                  setNumber1("");
                  setNumber2("");
                  setLockingKitNo("");
                  setSelectedOption(null);
                  setBillFile(null);
                  setBillImage(null);
                  setIsEdit(false)
                }}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleModalSubmit} className="theme_new_color">
              <div className="contact-grids-tab ">
                <ul className="nav nav-underline" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    Model Name - <b>{modelName}</b>
                    <br />
                    ModelNumber - <b>{modelNumber}</b>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="basic-info2"
                  role="tabpanel"
                  aria-labelledby="info-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            IMEI/Serial Number
                            <span className="text-danger"> *</span>
                          </label>
                          <CommonSelect
                            className="select"
                            options={imeiOptions}
                            defaultValue={imeiOptions.find(
                              (opt) => opt.value === imeiNumber
                            )}
                            onChange={(e) => setImeiNumber(e.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Number 1<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            value={number1}
                            className="form-control"
                            onChange={(e) => setNumber1(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Number 2<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={number2}
                            onChange={(e) => setNumber2(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Locking Kit No
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={lockingKitNo}
                            onChange={(e) => setLockingKitNo(e.target.value)}
                          />
                        </div>
                      </div>
                      {/* <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Bill Image<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={(e) =>
                              setBillFile(e.target.files?.[0] || null)
                            }
                          />
                        </div>
                      </div> */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Bill Image<span className="text-danger"> *</span>
                          </label>

                          {/* Show image if already uploaded and no new file is selected */}
                          {billImage && !billFile ? (
                            <div>
                              <img
                                src={typeof billImage === "string" ? billImage : URL.createObjectURL(billImage)}
                                alt="Bill Preview"
                                style={{ width: "100%", maxHeight: "200px", objectFit: "contain", marginBottom: "10px" }}
                              />
                              {JSON.parse(mtIdString)?.type !== "financer" && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-secondary"
                                  onClick={() => setBillImage(null)}
                                >
                                  Change Image
                                </button>
                              )}
                            </div>
                          ) : (
                            // Show file input if no image or a new file is selected
                            <input
                              type="file"
                              className="form-control"
                              onChange={(e) => {
                                const file = e.target.files?.[0] || null;
                                setBillFile(file);
                              }}
                            />
                          )}
                        </div>
                      </div>

                    </div>
                  </div>
                  <div className="modal-footer">
                    {!isEdit && (
                      <>
                        <button
                          type="button"
                          className="btn btn-outline-light border me-2"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setImeiNumber("");
                            setNumber1("");
                            setNumber2("");
                            setLockingKitNo("");
                            setSelectedOption(null);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          data-bs-dismiss="modal"
                          className="btn btn-primary"
                        >
                          Submit{" "}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <CustomerDetails customerData={customerData} />
      <DisbursementDetails
        allDisbursementData={allDisbursementData}
        onDeleted={fetchAllDisbursements}
      />
      <CustomerDocument customerData={customerData} />
      <GuarantorDetails customerData={customerData} />
      <SanctionalLetter
        sanctionalData={sanctionalData}
        handleSanctionLetter={handleSanctionLetter}
      />
      <BankDetails customerData={customerData} />
      <EMandate customerData={customerData} />
      <ENach customerData={enachData} />

      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default CustomerLoanList;
